const Constants = {

  applicationName: 'RansomStop',

  customerName: 'qa3',
  apiHost: 'qa3-api',
  domainName: 'ransomstop.com',
  version: '2.3.1',
  userPoolId: 'us-east-1_ZbtGsSoyX',
  userPoolClientId: '25ckivo32t9a8pjpb45ehopo2j',
  authDomain: 'qa3-ransomstop-com.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',
  showBilling: false,
}
export default Constants